import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../../redux/connect';
import { withRouter } from 'react-router-dom';
import { fetchProjectFolders, fetchFolderContents, openPushpinSelection, closePushpinSelection } from '../../../redux/actions';
import { getEnv, getRegion } from '../../../redux/selectors';
import { Text, IconButton, SvgIcon } from '@adsk/bim360-matrix-react-components';
import DocumentPicker from '../../../components/DocumentPicker';
import AddDocumentButton from '../../../components/AddDocumentButton';

class LinkToDocument extends PureComponent {

  renderDocument() {
    const { document, onRemoveDocument } = this.props;
    return (
      <div className="LinkToDocumentField__document">
        {/* Hiding tooltip as Text tooltip in modal is problematic in IE - https://git.autodesk.com/BIM360/bim360-matrix-react-components/issues/397 */}
        <Text className="LinkToDocumentField__document-name" ellipsis hideTooltip>
          {document.name}
        </Text>
        <IconButton
          className="LinkToDocumentField__document-remove-btn"
          onClick={() => onRemoveDocument(document)}
          styleType={IconButton.StyleType.MINIMAL}
        >
          <SvgIcon svgId="cancel-input-round" />
        </IconButton>
      </div>
    );
  }

  render() {
    const { document, status } = this.props;
    return (
      <DocumentPicker container={this.props.container} onSelectDocumentPushpin={this.props.onSelectDocumentPushpin} status={status}>
        {(startDocumentSelection) => {
          return (
            <div className="LinkToDocumentField">
              {document ? this.renderDocument() : <AddDocumentButton onClick={startDocumentSelection} />}
            </div>
          );
        }}
      </DocumentPicker>
    );
  }
}

LinkToDocument.displayName = 'LinkToDocument';

LinkToDocument.propTypes = {
  container: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  document: PropTypes.object,
  onSelectDocumentPushpin: PropTypes.func.isRequired,
  onRemoveDocument: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    region: getRegion(state),
    env: getEnv(state),
  };
};

export default connect(mapStateToProps, {
  fetchProjectFolders,
  fetchFolderContents,
  openPushpinSelection,
  closePushpinSelection,
})(withRouter(LinkToDocument));
